import { render, staticRenderFns } from "./SupportWarrantyPolicyTable.vue?vue&type=template&id=a109931c&"
import script from "./SupportWarrantyPolicyTable.vue?vue&type=script&lang=js&"
export * from "./SupportWarrantyPolicyTable.vue?vue&type=script&lang=js&"
import style0 from "./SupportWarrantyPolicyTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VChip,VIcon,VSimpleTable})
